import { InputType } from "../components/sop/inputPanel";

const formFields = {
  endpoint: "financials",
  inputs: [
    {
      name: "sponsoring_by",
      label: "Sponsoring By",
      placeholder: "Government Scholarship",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "father_occupation",
      label: "Father's Occupation",
      placeholder: "Business",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: false,
    },
    {
      name: "mother_occupation",
      label: "Mother's Occupation",
      placeholder: "Housewife",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: false,
    },

    {
      name: "total_fees",
      label: "Total Fees",
      placeholder: "25000 CAD",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "tution_fees_paid",
      label: "Tution Fees Paid",
      placeholder: "1000 CAD",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: false,
    },
    {
      name: "investment_account",
      label: "Investment Account",
      placeholder: "GIC",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "family_income",
      label: "Annual Family Income",
      placeholder: "25000 CAD",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "scholarship",
      label: "Relevant scholarship",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 100,
      required: false,
    },
  ],
};

export default formFields;
